import { isRichTextValueConsideredEmpty } from '@uniformdev/richtext';

import { Accordion } from '@/libraries/design/components/accordion/src/accordion.tsx';
import { RichTextComponent } from '@/libraries/design/utils';

export interface UniformAccordionProps {
	header: string;
	anchorId?: string;
	textBody?: string;
	richText?: string;
	uniformRichText?: unknown;
}
const UniformAccordion = (props: UniformAccordionProps) => {
	const { header, anchorId, textBody, richText } = props;
	return (
		<Accordion
			header={header}
			id={anchorId}
			content={
				richText ? (
					<RichTextComponent text={richText} />
				) : !isRichTextValueConsideredEmpty(props.uniformRichText) ? (
					<RichTextComponent uniformParameter="uniformRichText" />
				) : (
					textBody
				)
			}
		/>
	);
};

export default UniformAccordion;
